module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"editTitle":"Wärmenetz bearbeiten","createTitle":"Wärmenetz erstellen","buildingsTitle":"Aktuell angeschlossene Liegenschaften","identifierTitle":"Nr.","total":"Total","descriptionTitle":"Bezeichnung","endEnergyTitle":"Endenergiebedarf"}}')
  delete Component.options._Ctor
}
